(function ($) {
  /**
   * Object for management Low-FODMAP Plan product page controls.
   */
  window.MealPlan = {
    definedLimit: true,
    type: 'Plan_1',
    diet_type: 'Low-FODMAP Plan',
    mealPlan: {
      breakfast: true,
      id: null,
      type: null,
    },
    dietitian: {
      id: null,
    },
    exclude: [],
    minPurchaseAmount: localStorage.getItem('minPurchase'),
    note: '',
    additsCount: 0,
    addits: {},
    additionals: [],
    subscripts: {
      mealplan: null,
      dietitian: null,
      additis: {},
    },
    excludeLabes: [],
    attrs: {},
    minAdditsCount: 0, // Special variable for Mediterranean Program with minimum 10 entrees limitation
    defaultAdditsCount: 8, // Default value
    //DOM nodes
    $additsQty: null,
    $additsСount: null,
    $additsButInc: null,
    $additsButDec: null,
    $additsItemQty: null,
    $additiviesPrice: null,
    $breakfastYes: null,
    $breakfastNo: null,
    $dietitianYes: null,
    $dietitianNo: null,
    $additsClearAll: null,
    $mealPlanType: null,
    $dietType: null,
    $productFormCartMeals: null,
    $productFormCartSubmit: null,
    $additsProceedToCartMsg: null,
    $additsMsgZero: null,
    $additsMsgNotEnough: null,
    $additsMsgAdded: null,
    $breakfastInput: null,
    $entreesInput: null,
    $dietitianPrice: null,
    initNodes: function () {
      this.$additsQty = $('.addits-qty');
      this.$additsСount = $('#addits_count');
      this.$additiviesPrice = $('#additivies_price');
      this.$additsButInc = $('.addits-but-inc');
      this.$additsButDec = $('.addits-but-dec');
      this.$additsItemQty = $('.addits-item-qty');
      this.$breakfastYes = $('#breakfast_yes');
      this.$breakfastNo = $('#breakfast_no');
      this.$additsClearAll = $('.addits_clear_all');
      this.$dietitianYes = $('#dietitian_yes');
      this.$dietitianNo = $('#dietitian_no');
      this.$mealPlanType = $('#meal_plan_type');
      this.$dietType = $('#diet_type');
      this.$productFormCartMeals = $('.product-form__cart-meals');
      this.$productFormCartSubmit = $('.product-form__cart-submit');
      this.$additsProceedToCartMsg = $('.addits_proceed_to_cart_msg');
      this.$additsMsgZero = $('.addits_msg_zero');
      this.$additsMsgNotEnough = $('.addits_msg_not_enough');
      this.$additsMsgAdded = $('.addits_msg_added');
      this.$breakfastInput = $('.addits-item-qty[data-type="Breakfast"] .addits-qty');
      this.$entreesInput = $('.addits-item-qty[data-type="Entrée"] .addits-qty');
      this.$dietitianPrice = $('#dietitian_price');
    },
    enableCTAListener: function () {
      var $this = this;

      function checkAndShowControls() {
        var _MHdefinedLimit = window.MHdefinedLimit;
        $this.definedLimit = typeof _MHdefinedLimit === 'undefined' ? true : _MHdefinedLimit;
        if ($this.definedLimit === false) {
          $this.enableProductFormNextButton();
        }
      }

      checkAndShowControls();
      document.addEventListener('MH:NQ', checkAndShowControls);
    },
    /**
     * Check if the Plan is 'm1'
     */
    isBasic: function () {
      return this.type === 'Plan_1';
    },
    disableProductFormNextButton: function () {
      var $this = this;
      $this.$productFormCartMeals.attr('disabled', true);
      $this.$additsProceedToCartMsg.show();
    },
    enableProductFormNextButton: function () {
      var $this = this;
      $this.$productFormCartMeals.attr('disabled', false);
      $this.$additsProceedToCartMsg.hide();
    },
    /**
     * Enable + and - additionals quantity and submit buttons
     */
    enableAdditionalCountersAndSubmit: function () {
      var $this = this,
        additionalsQuantity = 0;
      var isClickExecuted = Number(this.$additsQty[0].value) || Number(this.$additsQty[1].value);
      if ($this.diet_type === 'Care Plan' && !isClickExecuted) {
        this.$additsButInc.click();
      }

      this.$additsQty.each(function (_index, item) {
        if ($(item).val() !== $this.minAdditsCount.toString()) {
          $(item).attr('disabled', false).removeClass('disabled');
          $(item).parent().find('button').attr('disabled', false);
        }
        additionalsQuantity += parseInt($(item).val());
      });
      if (additionalsQuantity >= this.minPurchaseAmount) {
        this.$productFormCartMeals.attr('disabled', false);
        this.$additsProceedToCartMsg.hide();
      }

      this.updateSavedTotalCounter();
    },
    /**
     * Update saved counter value
     */
    updateSavedTotalCounter: function () {
      var mealPlanType = this.mealPlan.type,
        modifyConstructorStorage = localStorage.getItem('modifyConstructorStorage');

      if (modifyConstructorStorage === null) return;

      modifyConstructorStorage = JSON.parse(modifyConstructorStorage);
      var _shopifyLimitations = modifyConstructorStorage.shopifyLimitations;
      var mealPlanTypeLF = modifyConstructorStorage.selectedDiet;

      if (typeof _shopifyLimitations === 'undefined') return;

      switch (mealPlanType) {
        case 'LF-Program':
          if (mealPlanTypeLF === 'LF-Program') {
            this.additsCount =
              typeof _shopifyLimitations.breakfastsMinLimit !== 'undefined' && typeof _shopifyLimitations.entreesMinLimit !== 'undefined'
                ? parseInt(_shopifyLimitations.breakfastsMinLimit) + parseInt(_shopifyLimitations.entreesMinLimit)
                : 0;
          }
          break;
        case 'LF-Meals':
          if (mealPlanTypeLF === 'LF-Meals') {
            this.additsCount =
              typeof _shopifyLimitations.breakfastsMinLimit !== 'undefined' && typeof _shopifyLimitations.entreesMinLimit !== 'undefined'
                ? parseInt(_shopifyLimitations.breakfastsMinLimit) + parseInt(_shopifyLimitations.entreesMinLimit)
                : 0;
          }
          break;
        case 'MD-Program':
          this.additsCount =
            typeof _shopifyLimitations.mediterraneanEntreesMinLimit !== 'undefined'
              ? parseInt(_shopifyLimitations.mediterraneanEntreesMinLimit)
              : 0;
          this.additsCount = this.additsCount > this.minAdditsCount ? this.additsCount : this.minAdditsCount;
          break;
        case 'MD-Meals':
          this.additsCount =
            typeof _shopifyLimitations.mediterraneanEntreesMinLimit !== 'undefined'
              ? parseInt(_shopifyLimitations.mediterraneanEntreesMinLimit)
              : 0;
          this.additsCount = this.additsCount > this.minAdditsCount ? this.additsCount : this.minAdditsCount;
          break;
        case 'DB-Program':
          this.additsCount =
            typeof _shopifyLimitations.mediterraneanEntreesMinLimit !== 'undefined'
              ? parseInt(_shopifyLimitations.mediterraneanEntreesMinLimit)
              : 0;
          this.additsCount = this.additsCount > this.minAdditsCount ? this.additsCount : this.minAdditsCount;
          break;
        case 'DB-Meals':
          this.additsCount =
            typeof _shopifyLimitations.mediterraneanEntreesMinLimit !== 'undefined'
              ? parseInt(_shopifyLimitations.mediterraneanEntreesMinLimit)
              : 0;
          this.additsCount = this.additsCount > this.minAdditsCount ? this.additsCount : this.minAdditsCount;
          break;
        case 'GF-Program':
          if (mealPlanTypeLF === 'GF-Program') {
            this.additsCount =
              typeof _shopifyLimitations.breakfastsMinLimit !== 'undefined' && typeof _shopifyLimitations.entreesMinLimit !== 'undefined'
                ? parseInt(_shopifyLimitations.breakfastsMinLimit) + parseInt(_shopifyLimitations.entreesMinLimit)
                : 0;
          }
          break;
        case 'GF-Meals':
          if (mealPlanTypeLF === 'GF-Meals') {
            this.additsCount =
              typeof _shopifyLimitations.breakfastsMinLimit !== 'undefined' && typeof _shopifyLimitations.entreesMinLimit !== 'undefined'
                ? parseInt(_shopifyLimitations.breakfastsMinLimit) + parseInt(_shopifyLimitations.entreesMinLimit)
                : 0;
          }
          break;
        case 'HF-Program':
          this.additsCount =
            typeof _shopifyLimitations.mediterraneanEntreesMinLimit !== 'undefined'
              ? parseInt(_shopifyLimitations.mediterraneanEntreesMinLimit)
              : 0;
          this.additsCount = this.additsCount > this.minAdditsCount ? this.additsCount : this.minAdditsCount;
          break;
        case 'HF-Meals':
          this.additsCount =
            typeof _shopifyLimitations.mediterraneanEntreesMinLimit !== 'undefined'
              ? parseInt(_shopifyLimitations.mediterraneanEntreesMinLimit)
              : 0;
          this.additsCount = this.additsCount > this.minAdditsCount ? this.additsCount : this.minAdditsCount;
          break;
        case 'CC-Program':
          if (mealPlanTypeLF === 'CC-Program') {
            this.additsCount =
              typeof _shopifyLimitations.breakfastsMinLimit !== 'undefined' && typeof _shopifyLimitations.entreesMinLimit !== 'undefined'
                ? parseInt(_shopifyLimitations.breakfastsMinLimit) + parseInt(_shopifyLimitations.entreesMinLimit)
                : 0;
          }
          break;
        case 'CC-Meals':
          if (mealPlanTypeLF === 'CC-Meals') {
            this.additsCount =
              typeof _shopifyLimitations.breakfastsMinLimit !== 'undefined' && typeof _shopifyLimitations.entreesMinLimit !== 'undefined'
                ? parseInt(_shopifyLimitations.breakfastsMinLimit) + parseInt(_shopifyLimitations.entreesMinLimit)
                : 0;
          }
          break;
        case 'B2B-Program':
          if (mealPlanTypeLF === 'B2B-Program') {
            this.additsCount =
              typeof _shopifyLimitations.breakfastsMinLimit !== 'undefined' && typeof _shopifyLimitations.entreesMinLimit !== 'undefined'
                ? parseInt(_shopifyLimitations.breakfastsMinLimit) + parseInt(_shopifyLimitations.entreesMinLimit)
                : 0;
          }
          break;
        case 'B2B-Meals':
          if (mealPlanTypeLF === 'B2B-Meals') {
            this.additsCount =
              typeof _shopifyLimitations.breakfastsMinLimit !== 'undefined' && typeof _shopifyLimitations.entreesMinLimit !== 'undefined'
                ? parseInt(_shopifyLimitations.breakfastsMinLimit) + parseInt(_shopifyLimitations.entreesMinLimit)
                : 0;
          }
          break;
        case 'CM-Meals':
          if (mealPlanTypeLF === 'CM-Meals') {
            this.additsCount =
              typeof _shopifyLimitations.breakfastsMinLimit !== 'undefined' && typeof _shopifyLimitations.entreesMinLimit !== 'undefined'
                ? parseInt(_shopifyLimitations.breakfastsMinLimit) + parseInt(_shopifyLimitations.entreesMinLimit)
                : 0;
          }
          break;
          case 'GLP-1-Program':
            if (mealPlanTypeLF === 'GLP-1-Program') {
              this.additsCount =
                  typeof _shopifyLimitations.breakfastsMinLimit !== 'undefined' && typeof _shopifyLimitations.entreesMinLimit !== 'undefined'
                    ? parseInt(_shopifyLimitations.breakfastsMinLimit) + parseInt(_shopifyLimitations.entreesMinLimit)
                    : 0;
              }
            break;
          case 'GLP-1-Meals':
            if (mealPlanTypeLF === 'GLP-1-Meals') {
              this.additsCount =
                typeof _shopifyLimitations.breakfastsMinLimit !== 'undefined' && typeof _shopifyLimitations.entreesMinLimit !== 'undefined'
                  ? parseInt(_shopifyLimitations.breakfastsMinLimit) + parseInt(_shopifyLimitations.entreesMinLimit)
                  : 0;
            }
            break;
        default:
          console.log('Meal plan is unknown');
      }
      if (this.$additsСount.length && this.additsCount !== 0) {
        this.$additsСount.text(this.additsCount);
      }

      this.triggerQty();
    },
    /**
     * Add to cart submit button loader
     */
    addToCartLoader: function () {
      if (!this.$productFormCartSubmit.length) return false;

      this.$productFormCartSubmit.on('click', function () {
        if (!$(this).attr('disabled')) {
          $(this).addClass('loading');
        }
      });
    },
    isNoQuantityMode: function () {
      var _MHdefinedLimit = window.MHdefinedLimit;
      var _definedLimit = typeof _MHdefinedLimit === 'undefined' ? true : _MHdefinedLimit;
      return !_definedLimit;
    },
    /**
     * Track additional meals update quantity
     */
    triggerQty: function () {
      var $this = this,
        enough = false;

      if (this.isBasic()) {
        enough = true;
      } else {
        if (this.additsCount >= this.minPurchaseAmount) {
          enough = true;
        }
      }

      this.$additsMsgZero.hide();

      if (!this.isNoQuantityMode() && this.$additsСount.length) {
        if (this.additsCount < this.minPurchaseAmount) {
          this.$additsСount.css('color', '#df4f30');
          this.$productFormCartSubmit.prop('disabled', true);
          this.$productFormCartMeals.prop('disabled', true);
          this.$additsProceedToCartMsg.show();
          this.$additsMsgNotEnough.show();
          this.$additsMsgAdded.hide();
        } else {
          this.$additsСount.css('color', '#43AF49');
          this.$productFormCartSubmit.prop('disabled', false);
          this.$productFormCartMeals.prop('disabled', false);
          this.$additsProceedToCartMsg.hide();
          this.$additsMsgNotEnough.hide();
          this.$additsMsgAdded.show();
        }
      }

      this.$additsСount.text(this.additsCount);
      $('.addits_count_left').text(this.additsCount < this.minPurchaseAmount ? this.minPurchaseAmount - this.additsCount : '');
      if (this.additsCount === this.minPurchaseAmount - 1) {
        $('.plural-s').hide();
      } else {
        $('.plural-s').show();
      }

      // Disable '-' button
      this.$additsItemQty.each(function () {
        var decBut = $(this).find('.addits-but-dec'),
          qty = parseInt($(this).find('.addits-qty').val());

        decBut.prop('disabled', qty === $this.minAdditsCount);
      });
      // Update price counter
      var additiviesTotal = 0,
        entreePrice = 0;

      var domAdditsCount = this.$additsQty.length ? parseInt(this.$additsQty.val()) : 0;

      $('.product-addits .addits-item-qty').each(function () {
        var price = parseFloat($(this).attr('data-price')),
          salePrice = parseFloat($(this).attr('data-saleprice')),
          qty = parseInt($(this).find('.addits-qty').val()),
          dividingPoint = typeof $(this).attr('data-dividing-point') !== 'undefined' ? parseInt($(this).attr('data-dividing-point')) : null;

        if (dividingPoint !== null) {
          price = qty < dividingPoint ? parseFloat($(this).attr('data-price-high')) : price;
        }

        if (
          domAdditsCount >= 10 &&
          $this.type === 'Plan_2' &&
          $this.diet_type === 'Mediterranean Plan' &&
          salePrice !== undefined &&
          salePrice > 0
        ) {
          additiviesTotal += salePrice * qty;
        } else if (
          domAdditsCount >= 10 &&
          $this.type === 'Plan_2' &&
          $this.diet_type === 'Diabetes Plan' &&
          salePrice !== undefined &&
          salePrice > 0
        ) {
          additiviesTotal += salePrice * qty;
        } else if (
          domAdditsCount >= 10 &&
          $this.type === 'Plan_2' &&
          $this.diet_type === 'Gluten-Free Plan' &&
          salePrice !== undefined &&
          salePrice > 0
        ) {
          additiviesTotal += salePrice * qty;
        } else if (
          domAdditsCount >= 10 &&
          $this.type === 'Plan_2' &&
          $this.diet_type === 'Heart-Friendly Plan' &&
          salePrice !== undefined &&
          salePrice > 0
        ) {
          additiviesTotal += salePrice * qty;
        } else if (
          domAdditsCount >= 10 &&
          $this.type === 'Plan_2' &&
          $this.diet_type === 'Carb-Conscious Plan' &&
          salePrice !== undefined &&
          salePrice > 0
        ) {
          additiviesTotal += salePrice * qty;
        } else if (
          domAdditsCount >= 10 &&
          $this.type === 'Plan_2' &&
          $this.diet_type === 'B2B Plan' &&
          salePrice !== undefined &&
          salePrice > 0
        ) {
          additiviesTotal += salePrice * qty;
        } else if (
          domAdditsCount >= 10 &&
          $this.type === 'Plan_2' &&
          $this.diet_type === 'Care Plan' &&
          salePrice !== undefined &&
          salePrice > 0
        ) {
          additiviesTotal += salePrice * qty;
        } else if (
          domAdditsCount >= 10 &&
          $this.type === 'Plan_2' &&
          $this.diet_type === 'GLP-1 Plan' &&
          salePrice !== undefined &&
          salePrice > 0
        ) {
          additiviesTotal += salePrice * qty;
        } else {
          additiviesTotal += price * qty;
          entreePrice = price;
        }
      });
      // if (this.isBasic() && this.diet_type === 'Mediterranean Plan') {
      //   additiviesTotal -= this.minAdditsCount * entreePrice;
      // }

      if (this.additsCount > 0) {
        if (additiviesTotal > 0) {
          $('#additivies_price .price-item--regular').text('$' + Number(additiviesTotal).toFixed(2));
          this.$additiviesPrice.show();
        } else {
          $('#additivies_price .price-item--regular').text('$' + Number(0).toFixed(2));
          this.$additiviesPrice.hide();
        }
      } else {
        $('#additivies_price .price-item--regular').text('$' + Number(0).toFixed(2));
        this.$additiviesPrice.hide();
      }
    },
    /**
     * Initialize products subscriptions
     */
    initSubscripts: function () {
      var $this = this;

      if (this.isBasic()) {
        // Meal plan
        this.subscripts.mealplan = $('.breakfast').closest('form').find('#rc_subscription_id').first().val();
      }

      this.$additsItemQty.each(function () {
        $this.subscripts.additis[$(this).attr('data-id')] = $(this).closest('.addits-item').find('#rc_subscription_id').first().val();
      });
    },
    /**
     * Format and display delivery date
     */
    showDeliveryDate: function (selector) {
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        date = ModifyHelpers.calculateDeliveryDateFromNow().split('-'),
        el = selector ? selector : '.delivery-date';

      $(el).text(months[parseInt(date[1]) - 1] + ' ' + parseInt(date[2]) + ', ' + date[0]);
    },
    getExcludes: function () {
      var excludes = [];

      var $excludes = $('.ingredient input');
      $excludes.each(function (_index, input) {
        if ($(input).is(':checked')) excludes.push($(input).parent().find('.ingredient-txt').text());
      });

      return excludes;
    },
    initDietPlan: function () {
      if (this.isBasic() && this.diet_type === 'Low-FODMAP Plan') this.mealPlan.type = 'LF-Program';
      if (!this.isBasic() && this.diet_type === 'Low-FODMAP Plan') this.mealPlan.type = 'LF-Meals';
      if (this.isBasic() && this.diet_type == 'Mediterranean Plan') this.mealPlan.type = 'MD-Program';
      if (!this.isBasic() && this.diet_type == 'Mediterranean Plan') this.mealPlan.type = 'MD-Meals';
      if (this.isBasic() && this.diet_type == 'Diabetes Plan') this.mealPlan.type = 'DB-Program';
      if (!this.isBasic() && this.diet_type == 'Diabetes Plan') this.mealPlan.type = 'DB-Meals';
      if (this.isBasic() && this.diet_type == 'Gluten-Free Plan') this.mealPlan.type = 'GF-Program';
      if (!this.isBasic() && this.diet_type == 'Gluten-Free Plan') this.mealPlan.type = 'GF-Meals';
      if (this.isBasic() && this.diet_type == 'Heart-Friendly Plan') this.mealPlan.type = 'HF-Program';
      if (!this.isBasic() && this.diet_type == 'Heart-Friendly Plan') this.mealPlan.type = 'HF-Meals';
      if (this.isBasic() && this.diet_type == 'Carb-Conscious Plan') this.mealPlan.type = 'CC-Program';
      if (!this.isBasic() && this.diet_type == 'Carb-Conscious Plan') this.mealPlan.type = 'CC-Meals';
      if (this.isBasic() && this.diet_type == 'B2B Plan') this.mealPlan.type = 'B2B-Program';
      if (!this.isBasic() && this.diet_type == 'B2B Plan') this.mealPlan.type = 'B2B-Meals';
      if (!this.isBasic() && this.diet_type == 'Care Plan') this.mealPlan.type = 'CM-Meals';
      if (this.isBasic() && this.diet_type == 'GLP-1 Plan') this.mealPlan.type = 'GLP-1-Program';
      if (!this.isBasic() && this.diet_type == 'GLP-1 Plan') this.mealPlan.type = 'GLP-1-Meals';
    },
    createShopifyLimitations: function () {
      var $this = this,
        _shopifyLimitations = {},
        mealPlanType = this.mealPlan.type,
        minPurchaseAmount = this.minPurchaseAmount;

      var breakfastInputVal = this.getBreakfastInputVal(),
        entreesInputVal = this.getEntreesInputVal();

      switch (mealPlanType) {
        case 'LF-Program':
          _shopifyLimitations = {
            breakfastsMinLimit: $this.isNoQuantityMode() ? 0 : breakfastInputVal,
            entreesMinLimit: $this.isNoQuantityMode() ? 0 : entreesInputVal,
            mediterraneanEntreesMinLimit: 0,
            additionalMealsMinLimit: {
              breakfastsMinLimit: 0,
              entreesMinLimit: 0,
              mediterraneanEntreesMinLimit: 0,
            },
          };
          break;
        case 'LF-Meals':
          _shopifyLimitations = {
            breakfastsMinLimit: $this.isNoQuantityMode() ? 0 : breakfastInputVal,
            entreesMinLimit: $this.isNoQuantityMode() ? 0 : entreesInputVal,
            mediterraneanEntreesMinLimit: 0,
            additionalMealsMinLimit: {
              breakfastsMinLimit: 0,
              entreesMinLimit: 0,
              mediterraneanEntreesMinLimit: 0,
            },
          };
          break;
        case 'MD-Program':
          _shopifyLimitations = {
            breakfastsMinLimit: 0,
            entreesMinLimit: 0,
            mediterraneanEntreesMinLimit: parseInt(minPurchaseAmount),
            additionalMealsMinLimit: {
              breakfastsMinLimit: 0,
              entreesMinLimit: 0,
              mediterraneanEntreesMinLimit: entreesInputVal - minPurchaseAmount > 0 ? entreesInputVal - minPurchaseAmount : 0,
            },
          };
          break;
        case 'MD-Meals':
          _shopifyLimitations = {
            breakfastsMinLimit: 0,
            entreesMinLimit: 0,
            mediterraneanEntreesMinLimit: parseInt(minPurchaseAmount),
            additionalMealsMinLimit: {
              breakfastsMinLimit: 0,
              entreesMinLimit: 0,
              mediterraneanEntreesMinLimit: entreesInputVal - minPurchaseAmount > 0 ? entreesInputVal - minPurchaseAmount : 0,
            },
          };
          break;
        case 'DB-Program':
          _shopifyLimitations = {
            breakfastsMinLimit: 0,
            entreesMinLimit: 0,
            mediterraneanEntreesMinLimit: parseInt(minPurchaseAmount),
            additionalMealsMinLimit: {
              breakfastsMinLimit: 0,
              entreesMinLimit: 0,
              mediterraneanEntreesMinLimit: entreesInputVal - minPurchaseAmount > 0 ? entreesInputVal - minPurchaseAmount : 0,
            },
          };
          break;
        case 'DB-Meals':
          _shopifyLimitations = {
            breakfastsMinLimit: 0,
            entreesMinLimit: 0,
            mediterraneanEntreesMinLimit: parseInt(minPurchaseAmount),
            additionalMealsMinLimit: {
              breakfastsMinLimit: 0,
              entreesMinLimit: 0,
              mediterraneanEntreesMinLimit: entreesInputVal - minPurchaseAmount > 0 ? entreesInputVal - minPurchaseAmount : 0,
            },
          };
          break;
        case 'GF-Program':
          _shopifyLimitations = {
            breakfastsMinLimit: breakfastInputVal,
            entreesMinLimit: entreesInputVal,
            mediterraneanEntreesMinLimit: 0,
            additionalMealsMinLimit: {
              breakfastsMinLimit: 0,
              entreesMinLimit: 0,
              mediterraneanEntreesMinLimit: 0,
            },
          };
          break;
        case 'GF-Meals':
          _shopifyLimitations = {
            breakfastsMinLimit: breakfastInputVal,
            entreesMinLimit: entreesInputVal,
            mediterraneanEntreesMinLimit: 0,
            additionalMealsMinLimit: {
              breakfastsMinLimit: 0,
              entreesMinLimit: 0,
              mediterraneanEntreesMinLimit: 0,
            },
          };
          break;
        case 'HF-Program':
          _shopifyLimitations = {
            breakfastsMinLimit: 0,
            entreesMinLimit: 0,
            mediterraneanEntreesMinLimit: parseInt(minPurchaseAmount),
            additionalMealsMinLimit: {
              breakfastsMinLimit: 0,
              entreesMinLimit: 0,
              mediterraneanEntreesMinLimit: entreesInputVal - minPurchaseAmount > 0 ? entreesInputVal - minPurchaseAmount : 0,
            },
          };
          break;
        case 'HF-Meals':
          _shopifyLimitations = {
            breakfastsMinLimit: 0,
            entreesMinLimit: 0,
            mediterraneanEntreesMinLimit: parseInt(minPurchaseAmount),
            additionalMealsMinLimit: {
              breakfastsMinLimit: 0,
              entreesMinLimit: 0,
              mediterraneanEntreesMinLimit: entreesInputVal - minPurchaseAmount > 0 ? entreesInputVal - minPurchaseAmount : 0,
            },
          };
          break;
        case 'CC-Program':
          _shopifyLimitations = {
            breakfastsMinLimit: breakfastInputVal,
            entreesMinLimit: entreesInputVal,
            mediterraneanEntreesMinLimit: 0,
            additionalMealsMinLimit: {
              breakfastsMinLimit: 0,
              entreesMinLimit: 0,
              mediterraneanEntreesMinLimit: 0,
            },
          };
          break;
        case 'CC-Meals':
          _shopifyLimitations = {
            breakfastsMinLimit: breakfastInputVal,
            entreesMinLimit: entreesInputVal,
            mediterraneanEntreesMinLimit: 0,
            additionalMealsMinLimit: {
              breakfastsMinLimit: 0,
              entreesMinLimit: 0,
              mediterraneanEntreesMinLimit: 0,
            },
          };
          break;
        case 'B2B-Program':
          _shopifyLimitations = {
            breakfastsMinLimit: breakfastInputVal,
            entreesMinLimit: entreesInputVal,
            mediterraneanEntreesMinLimit: 0,
            additionalMealsMinLimit: {
              breakfastsMinLimit: 0,
              entreesMinLimit: 0,
              mediterraneanEntreesMinLimit: 0,
            },
          };
          break;
        case 'B2B-Meals':
          _shopifyLimitations = {
            breakfastsMinLimit: breakfastInputVal,
            entreesMinLimit: entreesInputVal,
            mediterraneanEntreesMinLimit: 0,
            additionalMealsMinLimit: {
              breakfastsMinLimit: 0,
              entreesMinLimit: 0,
              mediterraneanEntreesMinLimit: 0,
            },
          };
          break;
        case 'CM-Meals':
          _shopifyLimitations = {
            breakfastsMinLimit: breakfastInputVal,
            entreesMinLimit: entreesInputVal,
            mediterraneanEntreesMinLimit: 0,
            additionalMealsMinLimit: {
              breakfastsMinLimit: 0,
              entreesMinLimit: 0,
              mediterraneanEntreesMinLimit: 0,
            },
          };
          break;
          case 'GLP-1-Program':
            _shopifyLimitations = {
              breakfastsMinLimit: breakfastInputVal,
              entreesMinLimit: entreesInputVal,
              mediterraneanEntreesMinLimit: 0,
              additionalMealsMinLimit: {
                breakfastsMinLimit: 0,
                entreesMinLimit: 0,
                mediterraneanEntreesMinLimit: 0,
              },
            };
            break;
          case 'GLP-1-Meals':
            _shopifyLimitations = {
              breakfastsMinLimit: breakfastInputVal,
              entreesMinLimit: entreesInputVal,
              mediterraneanEntreesMinLimit: 0,
              additionalMealsMinLimit: {
                breakfastsMinLimit: 0,
                entreesMinLimit: 0,
                mediterraneanEntreesMinLimit: 0,
              },
            };
            break;
        default:
          console.log('Meal plan is unknown');
      }

      return _shopifyLimitations;
    },
    //Remove obsolete dinner based record
    clearObsoleteLS: function () {
      var LSEntity = localStorage.getItem('modifyConstructorStorage');
      if (LSEntity === null) return false;
      LSEntity = JSON.parse(localStorage.getItem('modifyConstructorStorage'));
      if (typeof LSEntity.shopifyLimitations === 'undefined') return false;
      if (typeof LSEntity.shopifyLimitations.dinnerMinLimit !== 'undefined') {
        localStorage.removeItem('modifyConstructorStorage');
      }
    },
    formLSData: function (data) {
      var $this = this,
        localStorageData = {},
        breakfasts = 0,
        entrees = 0,
        additionalBreakfasts = 0,
        additionalEntrees = 0,
        mealPlanType = this.mealPlan.type,
        minPurchaseAmount = this.minPurchaseAmount;

      var breakfastInputVal = data.breakfastInputVal,
        entreesInputVal = data.entreesInputVal;

      this.additionals.forEach(function (item) {
        if (item.type === 'breakfast') {
          additionalBreakfasts += item.quantity;
        } else {
          additionalEntrees += item.quantity;
        }
      });

      if (!this.additionals.length) {
        additionalBreakfasts = data.breakfastInputVal;
        additionalEntrees = data.entreesInputVal;
      }

      additionalEntrees -= this.minAdditsCount;

      localStorageData = {
        definedLimit: typeof window.MHdefinedLimit === 'undefined' ? true : window.MHdefinedLimit,
        selectedExclusions: this.getExcludes(),
        shopifyLimitations: data.shopifyLimitations,
        configPageUrl: window.location.href,
        selectedDiet: this.mealPlan.type,
        dietType: this.diet_type,
        dietitian: data.dietitian,
      };

      switch (mealPlanType) {
        case 'LF-Program':
          breakfasts = breakfastInputVal;
          entrees = entreesInputVal;
          additionalBreakfasts = 0;
          additionalEntrees = 0;
          localStorageData.programType = 'Program';
          break;
        case 'LF-Meals':
          breakfasts = breakfastInputVal;
          entrees = entreesInputVal;
          additionalBreakfasts = 0;
          additionalEntrees = 0;
          localStorageData.programType = 'Meals';
          break;
        case 'MD-Program':
          entrees = minPurchaseAmount;
          additionalBreakfasts = 0;
          additionalEntrees = entreesInputVal - minPurchaseAmount > 0 ? entreesInputVal - minPurchaseAmount : 0;
          localStorageData.programType = 'Program';
          break;
        case 'MD-Meals':
          entrees = minPurchaseAmount;
          additionalBreakfasts = 0;
          additionalEntrees = entreesInputVal - minPurchaseAmount > 0 ? entreesInputVal - minPurchaseAmount : 0;
          localStorageData.programType = 'Meals';
          break;
        case 'DB-Program':
          entrees = minPurchaseAmount;
          additionalBreakfasts = 0;
          additionalEntrees = entreesInputVal - minPurchaseAmount > 0 ? entreesInputVal - minPurchaseAmount : 0;
          localStorageData.programType = 'Program';
          break;
        case 'DB-Meals':
          entrees = minPurchaseAmount;
          additionalBreakfasts = 0;
          additionalEntrees = entreesInputVal - minPurchaseAmount > 0 ? entreesInputVal - minPurchaseAmount : 0;
          localStorageData.programType = 'Meals';
          break;
        case 'GF-Program':
          breakfasts = breakfastInputVal;
          entrees = entreesInputVal;
          additionalBreakfasts = 0;
          additionalEntrees = 0;
          localStorageData.programType = 'Program';
          break;
        case 'GF-Meals':
          breakfasts = breakfastInputVal;
          entrees = entreesInputVal;
          additionalBreakfasts = 0;
          additionalEntrees = 0;
          localStorageData.programType = 'Meals';
          break;
        case 'HF-Program':
          entrees = minPurchaseAmount;
          additionalBreakfasts = 0;
          additionalEntrees = entreesInputVal - minPurchaseAmount > 0 ? entreesInputVal - minPurchaseAmount : 0;
          localStorageData.programType = 'Program';
          break;
        case 'HF-Meals':
          entrees = minPurchaseAmount;
          additionalBreakfasts = 0;
          additionalEntrees = entreesInputVal - minPurchaseAmount > 0 ? entreesInputVal - minPurchaseAmount : 0;
          localStorageData.programType = 'Meals';
          break;
        case 'CC-Program':
          breakfasts = breakfastInputVal;
          entrees = entreesInputVal;
          additionalBreakfasts = 0;
          additionalEntrees = 0;
          localStorageData.programType = 'Program';
          break;
        case 'CC-Meals':
          breakfasts = breakfastInputVal;
          entrees = entreesInputVal;
          additionalBreakfasts = 0;
          additionalEntrees = 0;
          localStorageData.programType = 'Meals';
          break;
        case 'B2B-Program':
          breakfasts = breakfastInputVal;
          entrees = entreesInputVal;
          additionalBreakfasts = 0;
          additionalEntrees = 0;
          localStorageData.programType = 'Program';
          break;
        case 'B2B-Meals':
          breakfasts = breakfastInputVal;
          entrees = entreesInputVal;
          additionalBreakfasts = 0;
          additionalEntrees = 0;
          localStorageData.programType = 'Meals';
          break;
        case 'CM-Meals':
          breakfasts = breakfastInputVal;
          entrees = entreesInputVal;
          additionalBreakfasts = 0;
          additionalEntrees = 0;
          localStorageData.programType = 'Meals';
          break;
          case 'GLP-1-Program':
            breakfasts = breakfastInputVal;
            entrees = entreesInputVal;
            additionalBreakfasts = 0;
            additionalEntrees = 0;
            localStorageData.programType = 'Program';
            break;
          case 'GLP-1-Meals':
            breakfasts = breakfastInputVal;
            entrees = entreesInputVal;
            additionalBreakfasts = 0;
            additionalEntrees = 0;
            localStorageData.programType = 'Meals';
            break;
        default:
          console.log('Meal plan is unknown');
      }

      if (this.isNoQuantityMode()) {
        localStorageData.limitations = {
          breakfastsMinLimit: 0,
          entreesMinLimit: 0,
          additionalMealsMinLimit: {
            breakfastsMinLimit: 0,
            entreesMinLimit: 0,
          },
        };
      } else {
        localStorageData.limitations = {
          breakfastsMinLimit: breakfasts,
          entreesMinLimit: parseInt(entrees),
          additionalMealsMinLimit: {
            breakfastsMinLimit: additionalBreakfasts,
            entreesMinLimit: additionalEntrees,
          },
        };
      }

      return localStorageData;
    },
    getDietitianData: function () {
      var $dietitian = this.$dietitianYes;

      return {
        id: $dietitian.length ? $dietitian.val() : '',
        support: $dietitian.length ? $dietitian.is(':checked') : false,
        price: mealConfigSS.dietitian.price,
      };
    },
    getBreakfastInputVal: function () {
      return this.$breakfastInput.length ? parseInt(this.$breakfastInput.val()) : 0;
    },
    getEntreesInputVal: function () {
      return this.$entreesInput.length ? parseInt(this.$entreesInput.val()) : 0;
    },
    saveMealConstructorInitData: function () {
      var localStorageData = {};

      //Remove obsolete dinner based record
      this.clearObsoleteLS();

      localStorageData = this.formLSData({
        breakfastInputVal: this.getBreakfastInputVal(),
        entreesInputVal: this.getEntreesInputVal(),
        dietitian: this.getDietitianData(),
        shopifyLimitations: this.createShopifyLimitations(),
      });

      localStorage.setItem('modifyConstructorStorage', JSON.stringify(localStorageData));
      window.location.href = '/pages/meals';
    },
    mealPlanBreakfastInit: function () {
      var $this = this;

      $('.breakfast input[name="id"]').on('click', function () {
        var isYes = $(this).attr('id') === 'breakfast_yes' && $(this).prop('checked'),
          valYes = $this.$breakfastYes.val(),
          valNo = $this.$breakfastNo.val(),
          priceYes = $this.$breakfastYes.attr('data-price'),
          priceNo = $this.$breakfastNo.attr('data-price');

        //Fix for name attr
        $this.$breakfastYes.attr('name', 'id');
        $this.$breakfastNo.attr('name', 'id');

        $this.mealPlan.breakfast = isYes;
        $this.mealPlan.id = isYes ? valYes : valNo;

        if (isYes) {
          $('.product__price:not(.no-update) .price-item--regular').text(priceYes);
          $this.$breakfastNo.prop('checked', false);
          $this.$breakfastYes.prop('checked', true);
        } else {
          $('.product__price:not(.no-update) .price-item--regular').text(priceNo);
          $this.$breakfastYes.prop('checked', false);
          $this.$breakfastNo.prop('checked', true);
        }
      });
      //Fix for name attr
      $this.$breakfastYes.trigger('click');
    },
    dietitianInit: function () {
      var $this = this,
        dietId = $('.dietitian input[name="dietitian_id"]').val();

      $('.dietitian input[name="dietitian_id"]').on('change', function () {
        var isYes = $(this).attr('id') === 'dietitian_yes';

        $this.dietitian = {
          id: isYes ? $(this).val() : null,
        };
        if (isYes) {
          $this.$dietitianPrice.show();
        } else {
          $this.$dietitianPrice.hide();
        }
      });

      this.dietitian = {
        id: dietId === '' ? null : dietId,
      };

      if (this.dietitian.id) {
        $this.$dietitianPrice.show();
      } else {
        $this.$dietitianPrice.hide();
      }
    },
    excludeIngredientsInit: function () {
      var $this = this;

      $('.ingredient input[type="checkbox"]').on('change', function () {
        var sel = $('.ingredient input[type="checkbox"]:checked');

        $this.exclude = [];
        $this.excludeLabes = [];

        sel.each(function (i, el) {
          $this.exclude.push($(el).val());
          var label = $(el).closest('.ingredient').find('label .ingredient-txt').text();
          $this.excludeLabes.push(label);
        });
      });
    },
    additsDecrementInit: function () {
      var $this = this;

      this.$additsButDec.on('click', function () {
        var addBlock = $(this).closest('.addits-item-qty'),
          addId = addBlock.attr('data-id'),
          qtyBlock = addBlock.find('.addits-qty'),
          qty = parseInt(qtyBlock.val());

        qty--;

        //Additional
        $this.additsCount--;
        if (qty <= 0) {
          delete $this.addits[addId];
          qty = 0;
          addBlock.find('.addits-but-dec').prop('disabled', true);
        } else {
          $this.addits[addId] = qty;
        }

        qtyBlock.val(qty);
        $this.triggerQty();
        if (qtyBlock.val() === '0') {
          qtyBlock.addClass('disabled');
        } else {
          qtyBlock.removeClass('disabled');
        }
      });
    },
    additsIncrementInit: function () {
      var $this = this;

      this.$additsButInc.on('click', function () {
        var addBlock = $(this).closest('.addits-item-qty');
        if ($this.diet_type !== 'Care Plan' || ($this.diet_type === 'Care Plan' && addBlock[0].dataset.type === 'Entrée')) {
          var addId = addBlock.attr('data-id');
          var qtyBlock = addBlock.find('.addits-qty');
          var qty = parseInt(qtyBlock.val());
          var toAdd = false;
          var type = $(this).parent('.addits-item-qty').attr('data-type');

          qty++;

          $this.additsCount++;
          $this.addits[addId] = qty;

          if ($this.additionals.length !== 0) {
            $this.additionals.forEach(function (item, index) {
              if (item.id === addId) {
                $this.additionals[index].quantity = qty;
                toAdd = false;
                return false;
              }
              toAdd = true;
            });

            if (toAdd) {
              $this.additionals.push({
                id: addId,
                quantity: qty,
                type: type === 'Entrée' ? 'entree' : 'breakfast',
              });
            }
          } else {
            $this.additionals.push({
              id: addId,
              quantity: qty,
              type: type === 'Entrée' ? 'entree' : 'breakfast',
            });
          }

          qtyBlock.val(qty);
          $this.triggerQty();
          if (qtyBlock.val() === '0') {
            qtyBlock.addClass('disabled');
          } else {
            qtyBlock.removeClass('disabled');
          }
        }
      });
    },
    /**
     * To Meals Constructor initializing
     */
    toMealsConstructorInit: function () {
      var $this = this;

      this.$productFormCartMeals.on('click', function (e) {
        e.preventDefault();

        if (!$('#qs-leftover').length && typeof window.Cookies !== 'undefined') {
          var discount = window.Cookies.get('mhDiscount');
          var prDs = window.theme.prDs;

          if (typeof prDs !== 'undefined' && discount === prDs) {
            window.Cookies.remove('mhDiscount');
          }
        }

        $this.saveMealConstructorInitData();
      });
    },
    /**
     * Add to Cart initializing
     */
    addToCartInit: function () {
      var $this = this;

      this.$productFormCartSubmit.on('click', function (e) {
        e.preventDefault();
        $this.addToCart();
      });
    },
    /**
     * Add products to cart
     */
    addToCart: function () {
      var $this = this;

      // Retrieve existent cart
      CartUtil.ajaxget('/cart.js', function (cart) {
        if (!cart.item_count.length) {
          CartUtil.updateAttrs({}, function () {
            CartUtil.updateNote('', function () {});
          });
        }

        var flStr = 'No ' + $this.exclude.join(',') + ';' + $this.note,
          attrs = $this.attrs,
          excludeStr = $this.exclude.join(','),
          excludeLabelsStr = $this.excludeLabes.join(', '),
          toAdd = ModifyHelpers.prepareSort(cart);

        attrs['deliveryDate'] = ModifyHelpers.calculateDeliveryDateFromNow();
        CartUtil.clear();


        if ($this.isBasic()) {
          // add meal plan m1
          toAdd.meal_plan.push({
            id: $this.mealPlan.id,
            qty: 1,
            properties: {
              fresh_lean: flStr,
              subscription_id: $this.subscripts.mealplan,
              recharge_subscription_id: $this.subscripts.mealplan,
              _shipping_interval_unit_type: 'Weeks',
              _shipping_interval_frequency: '1',
              exclude_codes: excludeStr,
              exclude_labels: excludeLabelsStr,
            },
          });

          // add Dietitian Consultation
          if ($this.dietitian.id) {
            toAdd.dietitian.push({
              id: $this.dietitian.id,
              qty: 1,
              properties: {
                healthieFulfills: 4,
              },
            });
            attrs['healthieScheduler'] = 'No';
          }
        }
        // add additional meals
        for (var id in $this.addits) {
          var mealPlan = $this.isBasic() ? 'm1' : 'm2',
            cartItem = {
              id: id,
              qty: $this.addits[id],
              properties: {
                fresh_lean: flStr,
                subscription_id: $this.subscripts.additis[id],
                recharge_subscription_id: $this.subscripts.additis[id],
                _shipping_interval_unit_type: 'Weeks',
                _shipping_interval_frequency: '1',
                meal_plan: mealPlan,
                exclude_codes: excludeStr,
                exclude_labels: excludeLabelsStr,
              },
            },
            additType = $('.addits-item-qty[id="' + id + '"]').attr('data-type');

          if (mealPlan === 'm1') {
            if (additType === 'Breakfast') {
              toAdd.addit_m1.b.push(cartItem);
            } else if (additType === 'Entrée') {
              toAdd.addit_m1.l.push(cartItem);
            } else {
              toAdd.addit_m1.d.push(cartItem);
            }
          } else {
            if (additType === 'Breakfast') {
              toAdd.addit_m2.b.push(cartItem);
            } else if (additType === 'Entrée') {
              toAdd.addit_m2.l.push(cartItem);
            } else {
              toAdd.addit_m2.d.push(cartItem);
            }
          }
        }
        ModifyHelpers.sortCartAndSubmit(toAdd, attrs);
      });
    },
    /**
     * Additional initializing
     */
    additsInit: function () {
      var $this = this;

      this.$additsQty.each(function () {
        var itemType = $(this).closest('.addits-item-qty').data('type'); // Check if item is an Entrée
        var defaultValue = $this.diet_type === 'Care Plan' ? 1 : 8; // Default value depends on diet type
        if (itemType === 'Entrée') {
          $(this).val(defaultValue); // Set default value
          $this.addits[$(this).closest('.addits-item-qty').data('id')] = defaultValue;
        } else if ($(this).val() < $this.minAdditsCount.toString()) {
          $(this).addClass('disabled');
        } else {
          $(this).removeClass('disabled');
        }
      });

      if (!this.isBasic()) {
        if (!this.isNoQuantityMode()) {
          this.$additsProceedToCartMsg.show();
          this.$productFormCartSubmit.prop('disabled', true);
          this.$productFormCartMeals.prop('disabled', true);
          this.$additsСount.css('color', '#df4f30');
        }
      }
      this.additsCount = this.defaultAdditsCount;
      this.enableAdditionalCountersAndSubmit();
    },
    getStateFromLocalStorage: function () {
      var $this = this,
        programType = $this.isBasic() ? 'Program' : 'Meals',
        _shopifyLimitations,
        mealPlanType = this.mealPlan.type,
        entreeLimitations,
        entreeValue,
        mealPlanTypeLF;

      this.clearObsoleteLS();

      if (localStorage.getItem('modifyConstructorStorage') === null) {
        this.$additsQty.each((_index, element) => $(element).val($this.minAdditsCount));
        if ($this.minAdditsCount > 0) {
          $this.addits[$('.addits-item-qty[data-type="Entrée"]').attr('data-id')] = $this.minAdditsCount;
        }
      } else {
        var modifyConstructorStorage = JSON.parse(localStorage.getItem('modifyConstructorStorage'));

        if (programType !== modifyConstructorStorage.programType) {
          modifyConstructorStorage.shopifyLimitations = {
            breakfastsMinLimit: 0,
            entreesMinLimit: 0,
            mediterraneanEntreesMinLimit: 0,
            additionalMealsMinLimit: {
              breakfastsMinLimit: 0,
              entreesMinLimit: 0,
              mediterraneanEntreesMinLimit: 0,
            },
          };

          modifyConstructorStorage.selectedExclusions = [];
        }

        _shopifyLimitations = modifyConstructorStorage.shopifyLimitations;

        if (typeof _shopifyLimitations === 'undefined') return false;

        mealPlanTypeLF = modifyConstructorStorage.selectedDiet;

        switch (mealPlanType) {
          case 'LF-Program':
            if (mealPlanTypeLF === 'LF-Program') {
              $this.$breakfastInput.val(_shopifyLimitations.breakfastsMinLimit);
              entreeValue = _shopifyLimitations.entreesMinLimit;
            } else {
              $this.$breakfastInput.val(0);
              entreeValue = 0;
            }
            break;
          case 'LF-Meals':
            if (mealPlanTypeLF === 'LF-Meals') {
              $this.$breakfastInput.val(_shopifyLimitations.breakfastsMinLimit);
              entreeValue = _shopifyLimitations.entreesMinLimit;
            } else {
              $this.$breakfastInput.val(0);
              entreeValue = 0;
            }
            break;
          case 'MD-Program':
            if (mealPlanTypeLF === 'MD-Program') {
              entreeLimitations = _shopifyLimitations.mediterraneanEntreesMinLimit;
              entreeValue = entreeLimitations;
            } else {
              entreeValue = $this.minPurchaseAmount;
            }
            break;
          case 'MD-Meals':
            if (mealPlanTypeLF === 'MD-Meals') {
              entreeLimitations = _shopifyLimitations.mediterraneanEntreesMinLimit;
              entreeValue = entreeLimitations;
            } else {
              entreeValue = $this.minPurchaseAmount;
            }
            break;
          case 'DB-Program':
            if (mealPlanTypeLF === 'DB-Program') {
              entreeLimitations = _shopifyLimitations.mediterraneanEntreesMinLimit;
              entreeValue = entreeLimitations;
            } else {
              entreeValue = $this.minPurchaseAmount;
            }
            break;
          case 'DB-Meals':
            if (mealPlanTypeLF === 'DB-Meals') {
              entreeLimitations = _shopifyLimitations.mediterraneanEntreesMinLimit;
              entreeValue = entreeLimitations;
            } else {
              entreeValue = $this.minPurchaseAmount;
            }
            break;
          case 'GF-Program':
            if (mealPlanTypeLF === 'GF-Program') {
              $this.$breakfastInput.val(_shopifyLimitations.breakfastsMinLimit);
              entreeValue = _shopifyLimitations.entreesMinLimit;
            } else {
              $this.$breakfastInput.val(0);
              entreeValue = 0;
            }
            break;
          case 'GF-Meals':
            if (mealPlanTypeLF === 'GF-Meals') {
              $this.$breakfastInput.val(_shopifyLimitations.breakfastsMinLimit);
              entreeValue = _shopifyLimitations.entreesMinLimit;
            } else {
              $this.$breakfastInput.val(0);
              entreeValue = 0;
            }
            break;
          case 'HF-Program':
            if (mealPlanTypeLF === 'HF-Program') {
              entreeLimitations = _shopifyLimitations.mediterraneanEntreesMinLimit;
              entreeValue = entreeLimitations;
            } else {
              entreeValue = $this.minPurchaseAmount;
            }
            break;
          case 'HF-Meals':
            if (mealPlanTypeLF === 'HF-Meals') {
              entreeLimitations = _shopifyLimitations.mediterraneanEntreesMinLimit;
              entreeValue = entreeLimitations;
            } else {
              entreeValue = $this.minPurchaseAmount;
            }
            break;
          case 'CC-Program':
            if (mealPlanTypeLF === 'CC-Program') {
              $this.$breakfastInput.val(_shopifyLimitations.breakfastsMinLimit);
              entreeValue = _shopifyLimitations.entreesMinLimit;
            } else {
              $this.$breakfastInput.val(0);
              entreeValue = 0;
            }
            break;
          case 'CC-Meals':
            if (mealPlanTypeLF === 'CC-Meals') {
              $this.$breakfastInput.val(_shopifyLimitations.breakfastsMinLimit);
              entreeValue = _shopifyLimitations.entreesMinLimit;
            } else {
              $this.$breakfastInput.val(0);
              entreeValue = 0;
            }
            break;
          case 'B2B-Program':
            if (mealPlanTypeLF === 'B2B-Program') {
              $this.$breakfastInput.val(_shopifyLimitations.breakfastsMinLimit);
              entreeValue = _shopifyLimitations.entreesMinLimit;
            } else {
              $this.$breakfastInput.val(0);
              entreeValue = 0;
            }
            break;
          case 'B2B-Meals':
            if (mealPlanTypeLF === 'B2B-Meals') {
              $this.$breakfastInput.val(_shopifyLimitations.breakfastsMinLimit);
              entreeValue = _shopifyLimitations.entreesMinLimit;
            } else {
              $this.$breakfastInput.val(0);
              entreeValue = 0;
            }
            break;
          case 'CM-Meals':
            if (mealPlanTypeLF === 'CM-Meals') {
              $this.$breakfastInput.val(_shopifyLimitations.breakfastsMinLimit);
              entreeValue = _shopifyLimitations.entreesMinLimit;
            } else {
              $this.$breakfastInput.val(0);
              entreeValue = 0;
            }
            break;
          case 'GLP-1-Program':
            if (mealPlanTypeLF === 'GLP-1-Program') {
              $this.$breakfastInput.val(_shopifyLimitations.breakfastsMinLimit);
              entreeValue = _shopifyLimitations.entreesMinLimit;
            } else {
              $this.$breakfastInput.val(0);
              entreeValue = 0;
            }
            break;
          case 'GLP-1-Meals':
            if (mealPlanTypeLF === 'GLP-1-Meals') {
              $this.$breakfastInput.val(_shopifyLimitations.breakfastsMinLimit);
              entreeValue = _shopifyLimitations.entreesMinLimit;
            } else {
              $this.$breakfastInput.val(0);
              entreeValue = 0;
            }
            break;
          default:
            console.log('Meal plan is unknown');
        }

        $this.$entreesInput.val(entreeValue);

        if ($this.isBasic()) {
          if (typeof _shopifyLimitations.breakfastNo !== 'undefined') {
            if (_shopifyLimitations.breakfastNo) {
              $this.$breakfastNo.trigger('click');
            } else {
              $this.$breakfastYes.trigger('click');
            }
            if (_shopifyLimitations.dietitian) {
              $this.$dietitianYes.trigger('click');
            } else {
              $this.$dietitianNo.trigger('click');
            }
          }
        }

        $this.setExclusionsFromSaved(modifyConstructorStorage);
      }
    },
    setExclusionsFromSaved: function (modifyConstructorStorage) {
      var $exclusionsWrap = $('.product-checkbox__group--exclusions');

      //Set Exclusions from saved
      if (modifyConstructorStorage.selectedExclusions.length && $exclusionsWrap.length) {
        modifyConstructorStorage.selectedExclusions.forEach(function (exclusion) {
          $('.ingredient-txt').each(function () {
            var itemText = $(this).text();

            if (itemText === exclusion) {
              $(this).closest('.ingredient').find('input').attr('checked', true);
            }
          });
        });
      }
    },
    /**
     * Clear all chosen meals amounts
     */
    clearAll: function () {
      var $this = this;

      this.$additsClearAll.on('click', function (e) {
        e.preventDefault();
        //Additional items
        $this.addits = {};
        $this.additsCount = $this.minAdditsCount;
        if ($this.minAdditsCount > 0) {
          $this.addits[$this.$additsItemQty.attr('data-id')] = $this.minAdditsCount;
        }
        $this.$additsQty.val($this.additsCount);
        $this.triggerQty();

        return false;
      });
    },
    /**
     * Initialize Meal Plan product page
     */
    init: function () {
      var $this = this;

      this.initNodes();

      if (this.$mealPlanType.length > 0) {
        this.type = this.$mealPlanType.val();
        // Just stub to init object only for meal plans
        if (['Plan_1', 'Plan_2'].indexOf(this.type) === -1) {
          if (this.type === 'Cart') {
            return MealCart.init();
          }
        } else {
          this.initSubscripts();
        }
      } else {
        return;
      }

      if (this.$dietType.length > 0) {
        this.diet_type = this.$dietType.val();
      }

      if (this.diet_type === 'Mediterranean Plan') {
        this.minAdditsCount = 6;
        this.defaultAdditsCount = 8; // Add default values for the corresponding plan
        $('.product__stage-item:nth-child(1) a').off('click');
        $('.product__stage-item:nth-child(1) a').attr('href', '/collections/mediterranean-plan');
      } else if (this.diet_type === 'Diabetes Plan') {
        this.minAdditsCount = 6;
        this.defaultAdditsCount = 8;
        $('.product__stage-item:nth-child(1) a').off('click');
        $('.product__stage-item:nth-child(1) a').attr('href', '/collections/diabetes-friendly-plan');
      } else if (this.diet_type === 'Gluten-Free Plan') {
        this.minAdditsCount = 0;
        $('.product__stage-item:nth-child(1) a').off('click');
        $('.product__stage-item:nth-child(1) a').attr('href', '/collections/gluten-free-plan');
      } else if (this.diet_type === 'Heart-Friendly Plan') {
        this.minAdditsCount = 6;
        this.defaultAdditsCount = 8;
        $('.product__stage-item:nth-child(1) a').off('click');
        $('.product__stage-item:nth-child(1) a').attr('href', '/collections/heart-friendly-plan');
      } else if (this.diet_type === 'Carb-Conscious Plan') {
        this.minAdditsCount = 0;
        $('.product__stage-item:nth-child(1) a').off('click');
        $('.product__stage-item:nth-child(1) a').attr('href', '/collections/carb-conscious-plan');
      } else if (this.diet_type === 'B2B Plan') {
        this.minAdditsCount = 0;
        $('.product__stage-item:nth-child(1) a').off('click');
        $('.product__stage-item:nth-child(1) a').attr('href', '/collections/b2b-plan');
      } else if (this.diet_type === 'Care Plan') {
        this.minAdditsCount = 0;
        $('.product__stage-item:nth-child(1) a').off('click');
        $('.product__stage-item:nth-child(1) a').attr('href', '/collections/care-plan');
      } else if (this.diet_type === 'GLP-1 Plan') {
        this.minAdditsCount = 0;
        $('.product__stage-item:nth-child(1) a').off('click');
        $('.product__stage-item:nth-child(1) a').attr('href', '/collections/glp-1-plan');
      }
      //if we need to have the page with collection (meals+program)
      this.mealPlan = {
        breakfast: true,
        id: $this.$breakfastYes.val(),
      };

      //Init states
      this.$additsButDec.prop('disabled', true);
      this.$additsQty.val($this.defaultAdditsCount); // Set default value
      $this.additsCount = $this.defaultAdditsCount;
      if ($this.defaultAdditsCount > 0) {
        $this.addits[$this.$additsItemQty.attr('data-id')] = $this.defaultAdditsCount;
      }

      this.initDietPlan();
      this.showDeliveryDate();
      this.addToCartLoader();
      this.clearAll();
      this.excludeIngredientsInit();
      this.additsDecrementInit();
      this.additsIncrementInit();
      this.addToCartInit();
      this.getStateFromLocalStorage();
      this.toMealsConstructorInit();
      this.additsInit();
      this.triggerQty();
      this.enableCTAListener();
    },
  };
})(jQuery);  